import styled, { css } from 'styled-components';
import { StyledIcon } from '../Icon/Icon';
import { modalDetailTokens } from '../../tokens/components/ModalDetail/tokens';
import { resetBrowserButton } from '../Button/styles';

export const DetailSidebarWrapper = styled.div`
  background-color: ${modalDetailTokens.SidebarBackgroundColorBaseDefault};
  color: ${modalDetailTokens.SidebarFontColorBaseDefault};
  display: flex;
  flex-direction: column;
  min-width: 220px;
  padding: ${modalDetailTokens.ContainerSpacingVertical} 0;
  border-radius: ${modalDetailTokens.ContainerBorderRadius} 0 0 ${modalDetailTokens.ContainerBorderRadius};

  ${({ theme }) =>
    theme.modalDetailMobile &&
    css`
      display: block;
      padding-bottom: 0;
      width: auto;
      border-radius: 0;
    `}

  @media print {
    display: none;
  }
`;

export const DetailSidebarDescription = styled.div`
  margin: 0 ${modalDetailTokens.ContainerSpacingHorizontal} ${modalDetailTokens.ContainerSpacingVertical};
  word-break: break-word;
`;

export const DetailSidebarList = styled.ul`
  ${({ theme }) =>
    theme.modalDetailMobile &&
    css`
      display: flex;
      overflow: scroll;
      padding: 0 ${modalDetailTokens.ContainerSpacingHorizontal};
    `}
`;

export const DetailSidebarClose = styled.div`
  align-items: center;
  background-color: ${modalDetailTokens.CloseActionBackgroundColorBaseDefault};
  color: ${modalDetailTokens.CloseActionGraphicColorBaseDefault};
  display: flex;
  font-size: ${modalDetailTokens.CloseActionGraphicSizeBaseDefault};
  justify-content: center;
  position: absolute;
  right: ${modalDetailTokens.ContainerSpacingHorizontal};
  top: calc(${modalDetailTokens.ContainerSpacingVertical} / 2);

  // Same code as BlockHeaderIcon
  ${StyledIcon} > svg {
    transition-duration: 60ms;
    transition-property: all;
    transition-timing-function: ease-in;
    transform: scale(0.75);
    transform-origin: center;
    color: ${modalDetailTokens.CloseActionGraphicColorBaseHover};
  }

  &:hover {
    text-decoration: none;

    ${StyledIcon} > svg {
      transform: scale(1);
      backface-visibility: hidden;
      perspective: 1000;
      text-decoration: none;
      will-change: auto;
    }
  }
`;

const detailSidebarItemStyle = css`
  ${resetBrowserButton}
  color: ${modalDetailTokens.ItemFontColorBaseDefault};
  cursor: pointer;
  font-size: ${modalDetailTokens.ItemFontSizeBaseDefault};
  font-weight: ${modalDetailTokens.ItemFontWeightBaseDefault};
  line-height: ${modalDetailTokens.ItemFontLeadingBaseDefault};
  padding: ${modalDetailTokens.ItemSpacingVerticalDesktop} ${modalDetailTokens.ContainerSpacingHorizontal};
  text-decoration: none;
  width: 100%;

  &:hover {
    color: ${modalDetailTokens.ItemFontColorBaseHover};
    text-decoration: none;
  }

  ${({ theme }) =>
    theme.modalDetailMobile &&
    css`
      width: max-content;
      padding: ${modalDetailTokens.ItemSpacingVerticalMobile} ${modalDetailTokens.ContainerSpacingHorizontal};
    `}

  ${({ theme }) =>
    theme.modalDetailSidebarItemActive &&
    css`
      background-color: ${modalDetailTokens.ItemBackgroundColorBaseDefault};
      color: ${modalDetailTokens.ItemFontColorActiveDefault};
    `}
`;

export const DetailSidebarItem = styled.div`
  ${detailSidebarItemStyle}
`;

export const DetailSidebarItemButton = styled.button`
  ${detailSidebarItemStyle}
`;

export const ModalDetailContent = styled.div`
  background-color: ${modalDetailTokens.ContentBackgroundColorBaseDefault};
  padding: ${modalDetailTokens.ContainerSpacingVertical} ${modalDetailTokens.ContainerSpacingHorizontal};
  width: 100%;
  border-radius: 0 ${modalDetailTokens.ContainerBorderRadius} ${modalDetailTokens.ContainerBorderRadius} 0;

  @media print {
    background-color: ${modalDetailTokens.ContentBackgroundColorBaseDefault};
    margin: 0;
    padding: 0;
  }
`;

export const ModalDetailWrapper = styled.div`
  display: flex;
  min-height: 27.75rem;

  @media print {
    display: block;
    margin: 0;
    width: auto;
  }

  ${({ theme }) =>
    theme.modalDetailMobile &&
    css`
      bottom: 0;
      flex-direction: column;
      left: 0;
      margin: 0 auto;
      position: fixed;
      right: 0;
      top: 0;

      ${ModalDetailContent} {
        flex: 1;
        overflow: scroll;
        border-radius: 0;
      }
    `}
`;
